import Client from './clients/Client'
const resource = '/status'

export default {
  getTweets () {
    return Client.get(`${resource}/tweets`)
  }
}
